module.exports = __webpack_public_path__ + "img/karolina-libelt@2x.d69ca964.jpg";